import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { memoize } from "lodash";
import { RoomDetail } from "@/types/room";
import { roomQueryOptions } from "@/api/provider/admin/room-query";
const emptyResult = {
  rooms: [] as RoomDetail[],
  roomMap: new Map<string, RoomDetail>()
};
const transformRooms = memoize((data: RoomDetail[] | null) => {
  return {
    rooms: data ?? [],
    roomMap: new Map(data?.map(room => [room.id, room]))
  };
});
export const useRooms = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...roomQueryOptions.list(),
      select: transformRooms
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data
  } = useQuery(t0);
  return data ?? emptyResult;
};